module.exports = __webpack_public_path__ + "img/Alchimeia_island_treasure.5835fa91.png";